import React from 'react';
import t from '~t';

import { Label, cn, Preloader, Icon } from '~ui';

const iconColor = {
  active: 'text-success',
  payment_failed: 'text-destructive',
  canceled: 'text-destructive',
};

export default function ProStatus({
  subscription: { status = '', plan = '', loading },
}) {
  let label = '';
  let icon = (
    <Icon
      name='diamond_active'
      className={cn(
        'transition-colors',
        iconColor[status] || 'text-accent',
      )}
    />
  );
  let period;

  //status
  if (loading) {
    icon = <Preloader />;
    label = t.s('loading') + '…';
  } else
    switch (status) {
      case 'payment_failed':
        label = t.s('paymentFailed');
        break;
      default:
        label = t.s(status);
        break;
    }

  //plan
  if (plan.includes('monthly')) period = ` (${t.s('monthly')})`;
  else if (plan.includes('annual')) period = ` (${t.s('yearly')})`;

  return (
    <>
      <Label>{t.s('subscription')}</Label>

      <div className='flex items-center self-center font-semibold text-[length:var(--head-font-size)] [&>:not(:last-child)]:mr-[var(--padding-small)]'>
        {icon}
        {label}
        {period}
      </div>
    </>
  );
}
